import axios from 'axios';
import routes from 'services/routes';

export const addUserAssinatura = params => (
  axios.post(routes.assinatura.addUser(), params)
);

export const fetchAssinatura = () => (
  axios.get(routes.assinatura.fetch())
);

export const updateUserAssinatura = params => (
  axios.patch(routes.assinatura.updateAdmin(), params)
);

export const removeUserAssinatura = userId => (
  axios.delete(routes.assinatura.removeUser(userId))
);



// WEBPACK FOOTER //
// ./src/services/assinatura.js